import React, { useEffect, useState } from "react";
import { useSchool } from "../../DataStore/SchoolContext";
import functions from "../../util/functions";
import ActivityLoader from "../Common/ActivityLoader";
import Notification from "../Common/Notification";
import ajaxSchool from "../../util/remote/ajaxSchool";
import { useTheme } from "../../DataStore/ThemeContext";

const BatchSelector = () => {
  

  const [selectedBatchId, setSelectedBatchId] = useState(null);
  const {getBatchListing, batchListing, getCurrentBatch} = useSchool();
  const {openSettings} = useTheme();
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(()=>{
    getBatchListing();
  }, [])
  

  const handleMakeCurrent = async () => {
    setLoading(true);
    const server_response = await ajaxSchool.switchBillingBatch(selectedBatchId);
    setLoading(false);
    if(server_response.status === "OK"){
        setInfo(<Notification message={server_response.message} type="success" closable={false} />);
        getBatchListing(true);
        getCurrentBatch(true);
    }else{
        setInfo(<Notification message={server_response.message} type="danger" closable={false} />);

    }
    setSelectedBatchId(null); // Clear selection after setting current
  };


  const handleEdit = (batchInfo)=>{
    openSettings("Edit Billing Batch", "EditFeesBatch", batchInfo);
  }

  return (
    <div className="position-relative">
      <div
        className="list-group list-group-flush overflow-auto"
        style={{ maxHeight: "80vh" }}
      >
        <h6 className="text-muted text-uppercase font-size-md opacity-5 font-weight-normal">Batch Selector</h6>
        {info}

        {Array.isArray(batchListing) &&  batchListing.map((batch) => (
          <button
            key={batch.id}
            className={`list-group-item list-group-item-action ${
              selectedBatchId === batch.id ? "active" : ""
            }`}
            onClick={() => setSelectedBatchId(batch.id)}
            onDoubleClick={()=>handleEdit(batch)}
          >
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h6 className="mb-1">{batch.batch_name}</h6>
                <small>
                  {functions.formatDate(batch.start_date)} - {functions.formatDate(batch.end_date)}
                </small>
              </div>
              {batch.current === "1" && (
                <span className="badge badge-success">Current</span>
              )}
            </div>
          </button>
        ))}
        {!batchListing && <ActivityLoader />}
        {batchListing === "404" && <Notification message="No billing batch is defined. Please create a New Batch to get started." closable={false} />}

      </div>

      {/* Make Current Button */}
      <div
        className="bg-white p-3 position-fixed w-100"
        style={{ bottom: "0", left: "0", zIndex: "1000", boxShadow: "0 -2px 5px rgba(0, 0, 0, 0.1)" }}
      >
        {!loading && <button
          className="btn btn-lg btn-success w-100"
          onClick={handleMakeCurrent}
          disabled={!selectedBatchId}
        >
          Make Current
        </button>}
        {loading && <ActivityLoader />}
      </div>
    </div>
  );
};

export default BatchSelector;
